module.exports = __webpack_public_path__ + "img/16.f12deb03.jpg";